<template>
  <div id="enquiryPurchaserPanelNewProcurmentMethodBody">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">1 招标方式</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <div class="panel-body-row-left">采购类型</div>
          <div class="panel-body-row-right">
            <el-radio class="eb-radio" v-model="project.projectType" label="1">物资</el-radio>
            <el-radio class="eb-radio" v-model="project.projectType" label="2">工程</el-radio>
            <el-radio class="eb-radio" v-model="project.projectType" label="3">服务</el-radio>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">开始时间</div>
          <div class="panel-body-row-right">
            <el-radio class="eb-radio" v-model="project.startType" label="1">发布时即开始</el-radio>
            <el-radio class="eb-radio" v-model="project.startType" label="2">指定日期时间</el-radio>
            <ebDateTimePicker v-show="project.startType==2" :time.sync="project.startTime" class="ebDateTimePicker startTime" :min-time="minTime" />
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">截标时间</div>
          <div class="panel-body-row-right">
            <ebDateTimePicker :time.sync="project.endTime" :min-time="minTime" />
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">开标形式</div>
          <div class="panel-body-row-right">
            <el-radio class="eb-radio" v-model="project.projectStyle" label="1">现场开标</el-radio>
            <el-radio class="eb-radio" v-model="project.projectStyle" label="2">非现场开标</el-radio>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">开标地点</div>
          <div class="panel-body-row-right">
            <el-input size="small" :disabled="project.projectStyle==2" v-model="project.bidProjectArea" class="eb-input bidProjectArea" placeholder="采购方所在地"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">开标时间</div>
          <div class="panel-body-row-right">
            <ebDateTimePicker :timePickerPickerOptions="timePickerPickerOptions" :time.sync="project.bidProjectOpenTime" :min-time="minTime" />
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">中标公示</div>
          <div class="panel-body-row-right">
            <el-radio class="eb-radio" v-model="project.resultPublic" label="1">不公示</el-radio>
            <el-radio class="eb-radio" v-model="project.resultPublic" label="2">部分公示</el-radio>
            <el-radio class="eb-radio" v-model="project.resultPublic" label="3">公示</el-radio>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">异议期</div>
          <div class="panel-body-row-right">
            <el-input size="small" :disabled="project.resultPublic!='3'" v-model="project.durationDays" class="eb-input durationDays" placeholder="异议期"></el-input>
            <span class="row-right-text">个自然日内</span>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">规则模板</div>
          <div class="panel-body-row-right">
            <SelectRuleTemplate ref="selectRuleTemplate" :project="project" @onDeleteRuleTemplate="deleteRuleTemplate" @onSelectRuleTemplate="selectRuleTemplate" />
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
// import moment from 'moment';
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import ebDateTimePicker from '@/components/common/eb-datetime-picker/eb-datetime-picker';
import { getProjectDefaultRuleTemplate } from '@/services/rule/rule-template-service';
import { setProjectRuleTemplate } from '@/services/proj/bid-project-service';
import SelectRuleTemplate from '@/components/project/SelectRuleTemplate';
// import { cloneDeep } from 'lodash';

export default {
  name: 'enquiryPurchaserPanelNewProcurmentMethodBody',
  props: ['project'],
  components: {
    ebPanel,
    ebPanelHeader,
    ebDateTimePicker,
    SelectRuleTemplate
  },
  data() {
    return {
      // defaultPickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() < moment().subtract(1, 'days').format('x');
      //   }
      // },
      // startTimePickerOptions: cloneDeep(this.defaultPickerOptions),
      // endTimePickerOptions: cloneDeep(this.defaultPickerOptions),
      // bidProjectOpenTimePickerOptions: cloneDeep(this.defaultPickerOptions),
      minTime: Date.now(),
      checked: true,
      user: this.$store.state.user.userInfo,
      timePickerPickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '24:00'
      }
    };
  },
  created() {
    this.initNewProjectTemplateInfo();
  },
  methods: {
    // 初始化招标项目默认模板
    async initNewProjectTemplateInfo() {
      try {
        if (!this.project || !this.project.projectId || !this.project.templateId) {
          let res = await getProjectDefaultRuleTemplate(this.user.orgId, 'BID');
          this.project.templateId = res.templateId;
          this.project.templateName = res.templateName;
        }
      } catch (err) {
        this.$message.error('加载招标项目默认模板失败');
      }
    },
    // 选中模板
    selectRuleTemplate(templateObj) {
      // 新建项目，修改字段
      if (!this.project || !this.project.projectId || !this.project.templateId) {
        this.project.templateId = templateObj.templateId;
        this.project.templateName = templateObj.templateName;
        this.$refs.selectRuleTemplate.dialogVisible = false;
      } else {
        // 草稿项目操作，删除原有已存入数据库的模板，替换为默认模板
        let _this = this;
        this.$ebConfirm('选择新的规则模板，将删除本项目对规则的自定义内容，使用新规则代替。是否确认？').then(() => {
          this.editProjectRuleTemplate('edit', templateObj.templateId, templateObj.templateName, function() {
            _this.$refs.selectRuleTemplate.dialogVisible = false;
          });
        });
      }
    },
    // 删除并恢复默认模板
    deleteRuleTemplate() {
      // getProjectDefaultRuleTemplate(this.user.orgId, 'PROJECT');
      let orgId = this.user.orgId;
      this.$ebConfirm('删除当前规则模板，将删除本项目中对规则的自定义内容，恢复为机构默认规则。是否确认？')
        .then(async result => {
          try {
            let res = await getProjectDefaultRuleTemplate(orgId, 'BID');
            if (!this.project || !this.project.projectId || !this.project.templateId) {
              // 新建项目，修改字段
              this.project.templateId = res.templateId;
              this.project.templateName = res.templateName;
            } else {
              // 草稿项目操作，删除原有已存入数据库的模板，替换为新的模板
              let _this = this;
              this.editProjectRuleTemplate('delete', res.templateId, res.templateName, function() {
                _this.$message.success('删除并恢复默认模板成功');
              });
            }
          } catch (err) {
            this.$message.error(err);
          }
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 修改项目模板
    async editProjectRuleTemplate(operType, templateId, templateName, done) {
      try {
        let { data } = await setProjectRuleTemplate(this.project.projectId, templateId);
        if (data.returnCode === '01') {
          this.project['templateId'] = templateId;
          this.project['templateName'] = templateName;
          done();
        } else {
          throw new Error('更新采购规则模板失败');
        }
      } catch (err) {
        this.$message.error(err);
      }
    }
  }
};
</script>
<style scoped lang="less">
.bidProjectArea {
  width: 320px;
}
.durationDays {
  width: 132px;
}
.startTime {
  margin-left: 20px;
}
</style>
